import React from 'react';
import { Image, Progress } from 'antd';
import '../assets/scss/UserInfoPanel.scss';

const UserInfoPanel = (props) => {
    return (
        <div className="info-wrap">
            <div className='contentWarp'>
                <div className='contentBg'>
                    <div className='columnBg'>
                        <Image preview={false} className='columnImg' src={require('../assets/img/detail_icon_login.png')} />
                        <div className='columnDetail'>
                            <div className='columnTitle' >连续登录次数</div>
                            <Progress 
                                strokeColor='#FF9C3E' 
                                trailColor='#BBBBBB' 
                                percent={parseInt((props.loginTimes || 0) / 7.0 * 100)} 
                                format={
                                    (percent) => { 
                                        return (
                                            <div style={{display:'flex'}}>
                                                <div style={{color:'#FF9C3E'}}>{(props.loginTimes || 0) + ''}</div>
                                                <div>{`/7`}</div>
                                            </div>
                                        ) 
                                    }
                                }
                            />
                        </div>
                    </div>
                    <div className='columnBg'>
                        <Image preview={false} className='columnImg' src={require('../assets/img/detail_icon_sum.png')} />
                        <div className='columnDetail'>
                            <div className='columnTitle' >消费金额满3000元(不含税)</div>
                            <Progress 
                                className='columnProgess_sum' 
                                strokeColor='#FF9C3E' 
                                trailColor='#BBBBBB' 
                                percent={parseInt((props.sumPrice || 0) / 3000.0 * 100)} 
                                format={
                                    (percent) => { 
                                        return (
                                            <div style={{display:'flex'}}>
                                                <div style={{color:'#FF9C3E'}}>{(props.sumPrice || 0) + ''}</div>
                                                <div>{`/3000`}</div>
                                            </div>
                                        ) 
                                    }
                                }
                            />
                        </div>
                    </div>
                    <div className='columnBg'>
                        <Image preview={false} className='columnImg' src={require('../assets/img/detail_icon_share.png')} />
                        <div className='columnDetail_share'>
                            <div className='columnTitle_share'>
                                <div>分享并成功推荐</div>
                                <div>新用户下载注册</div>
                            </div>
                            <Image preview={false} className='shareImg' src={require('../assets/img/detail_share.png')} onClick={props.didClickedShareBtn} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserInfoPanel;